module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<div class="vjs-chat-comment__reply" data-original-message-id="comment-<%= message.id %>">\n\t<div class="vjs-chat-comment__quote">\n\t\t<div class="vjs-chat-comment__quote-name"><%= message.author.name %></div>\n\t\t<div class="vjs-chat-comment__quote-text"><%= message.text %></div>\n\n\t\t<% if (message.attachments && message.attachments.length) { %>\n\t\t\t<div class="vjs-chat-comment__image-list">\n\t\t\t\t<% for (var i = 0; i < message.attachments.length; i++) { %>\n\t\t\t\t\t<img class="vjs-chat-comment__image" src="<%= message.attachments[i] %>">\n\t\t\t\t<% } %>\n\t\t\t</div>\n\t\t<% } %>\n\t</div>\n</div>', __filename = "videojs-chat/templates/comment-reply.html";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        with (locals || {}) {
            __append('<div class="vjs-chat-comment__reply" data-original-message-id="comment-');
            __append(escapeFn(message.id));
            __append('">\n\t<div class="vjs-chat-comment__quote">\n\t\t<div class="vjs-chat-comment__quote-name">');
            __line = 3;
            __append(escapeFn(message.author.name));
            __append('</div>\n\t\t<div class="vjs-chat-comment__quote-text">');
            __line = 4;
            __append(escapeFn(message.text));
            __append("</div>\n\n\t\t");
            __line = 6;
            if (message.attachments && message.attachments.length) {
                __append('\n\t\t\t<div class="vjs-chat-comment__image-list">\n\t\t\t\t');
                __line = 8;
                for (var i = 0; i < message.attachments.length; i++) {
                    __append('\n\t\t\t\t\t<img class="vjs-chat-comment__image" src="');
                    __line = 9;
                    __append(escapeFn(message.attachments[i]));
                    __append('">\n\t\t\t\t');
                    __line = 10;
                }
                __append("\n\t\t\t</div>\n\t\t");
                __line = 12;
            }
            __append("\n\t</div>\n</div>");
            __line = 14;
        }
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}